import windowObject from './windowObj';

export { default as dom } from './services/dom';

export default {
  window: windowObject,
  document: windowObject.document,
};
